/**
 * <announcement-bar-sticky>
 *
 * Enveloppe la barre d'annonce lorsque l'option « Barre d'annonce fixe » est
 * activée. Le composant mesure la hauteur réelle de la barre (padding, taille
 * de police, retour à la ligne sur mobile, masquage desktop/mobile...) et
 * l'expose dans la variable CSS globale `--announcement-bar-height`.
 *
 * Cette variable est utilisée par la feuille de style de la section pour caler
 * le header sticky juste en dessous de la barre, sans chevauchement.
 */

const instances = new Set();
let resizeObserver = null;

/**
 * Recalcule la hauteur cumulée des barres d'annonce sticky et met à jour la
 * variable CSS sur <html>.
 */
function updateOffset() {
  let height = 0;

  instances.forEach((element) => {
    height += element.offsetHeight;
  });

  document.documentElement.style.setProperty('--announcement-bar-height', `${height}px`);
}

class AnnouncementBarSticky extends HTMLElement {
  connectedCallback() {
    instances.add(this);

    if (!resizeObserver) {
      resizeObserver = new ResizeObserver(() => updateOffset());
    }

    resizeObserver.observe(this);

    // Le changement de breakpoint peut masquer la barre (mobile-hide /
    // desktop-hide) : on recalcule aussi au redimensionnement de la fenêtre.
    window.addEventListener('resize', updateOffset, { passive: true });

    updateOffset();
  }

  disconnectedCallback() {
    instances.delete(this);
    resizeObserver?.unobserve(this);
    window.removeEventListener('resize', updateOffset);

    updateOffset();
  }
}

if (!customElements.get('announcement-bar-sticky')) {
  customElements.define('announcement-bar-sticky', AnnouncementBarSticky);
}
